<template>
  <div class="products-modal-content-container">
    <div style="display: flex; align-items: end; gap: 5%; margin-bottom: 3%">
      <div class="management-modal-inputs-container-wrapper">
        <span class="management-modal-inputs-container-title">Filtrar produtos</span>
        <input
          :placeholder="'Digite o nome do produto'"
          @keyup.enter="inputEnter()"
          v-model="inputSearch"
          class="manage-categories__input"
        />
      </div>
      <Button
        title="Excel"
        :text="'Excel'"
        class="mobile-button-size"
        :iconName="'file_download'"
        :action="excelClick"
        style="height: 52px"
      />
    </div>

    <div class="management-modal-body">
      <div class="modal-table-header">
        <div class="modal-table-colum-id">Cod.</div>
        <div class="modal-table-colum-name">Nome</div>
        <div class="modal-table-colum-action">Nome</div>
      </div>
      <div
        v-for="(value, idx) in showList"
        :key="value.id"
        :class="{ 'page-table-line-special': idx % 2 != 0 }"
        class="modal-table-row"
      >
        <div class="modal-table-colum-id">{{ value.produto.pro_ean }}</div>
        <div class="modal-table-colum-name">{{ value.produto.pro_descricao }}</div>
        <div class="modal-table-colum-action">
          <span
            @click="deleteProduct(value.id)"
            class="material-icons-outlined modal-table-delete-icon"
            >delete</span
          >
        </div>
      </div>
      <h1 class="modal-empty-list" v-if="showList && showList.length == 0">
        Lista vazia
      </h1>
      <pagination
        classes="orange"
        :total="totalItems"
        :page="1"
        :page_limit="5"
        :items_by_page_value="30"
        v-on:change="loadPage($event)"
        style="margin-top: 5vh"
      />
    </div>
    <cc-loader-full v-if="isLoading" />
  </div>
</template>

<script>
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import ProductGroupService from "@/services/v3/management/ProductGroupService.js";
import pagination from "@/components/cliente/base-components/Pagination";
import ExcelDownload from "@/services/ExcelDownload.js";
import Button from "@/components/ui/buttons/Standard-Button.vue";

export default {
  name: "ListProductsModal",
  props: ["listId", "productsListId"],
  components: {
    StandardButton,
    pagination,
    Button,
  },
  data() {
    return {
      newGroupText: "",
      service: new ProductGroupService(),
      isLoading: false,
      showList: undefined,
      totalItems: undefined,
      inputSearch: "",
      searchTimeSpan: undefined,
    };
  },
  created() {
    this.loadPage(1);
  },
  watch: {
    inputSearch() {
      const localTimeStamp = Date.now();
      this.searchTimeSpan = localTimeStamp;
      setTimeout(() => {
        if (this.searchTimeSpan == localTimeStamp) this.loadPage(1);
      }, 2000);
    },
  },
  methods: {
    inputEnter() {
      this.searchTimeSpan = undefined;
      this.loadPage(1);
    },
    loadPage(page) {
      this.isLoading = true;
      this.service.getGroupProducts(this.listId, page, this.inputSearch).then((resp) => {
        this.showList = resp.data.data;
        this.isLoading = false;
        this.totalItems = resp.data.total;
      });
    },
    deleteProduct(id) {
      this.isLoading = true;
      this.service.deleteProduct(id).then(() => {
        this.isLoading = false;
        this.showList = this.showList.filter((element) => element.id != id);
      });
    },
    excelClick() {
      this.isLoading = true;
      this.service
        .getGroupProducts(this.listId, 1, this.inputSearch, true)
        .then((resp) => {
          const products = resp.data;
          this.isLoading = false;
          this.downloadExcel(products);
        });
    },
    downloadExcel(products) {
      setTimeout(() => {
        const store = localStorage.getItem("grupo");
        const payload = {
          tableName: "Produtos",
          groupName: this.productsListId ? this.productsListId.descricao : "",
          userName: localStorage.getItem("user_name"),
          author: this.whitelabel && this.whitelabel.data.providers.text_window,
          headerColor: this.whitelabel && this.whitelabel.data.colors.primary,
          store,
          header: ["Código EAN", "Código Interno", "Descrição", "Embalagem"],
          body: products.map((value) => {
            return [
              value.produto.pro_ean,
              value.produto.pro_id,
              value.produto.pro_descricao,
              value.produto.pro_generico == 1
                ? value.produto.pro_unidade_compra
                : value.produto.pro_embalagem,
            ];
          }),
          colWidths: [20, 25, 40, 20],
          styles: {
            headerStyle: {
              alignment: {
                horizontal: "center",
                vertical: "center",
              },
              font: {
                bold: true,
                color: { rgb: "FFFFFF" },
              },
              fill: {
                fgColor: {
                  rgb:
                    this.whitelabel && this.whitelabel.data.colors.primary
                      ? this.whitelabel.data.colors.primary.replace("#", "")
                      : "FF7110",
                },
              },
            },
            bodyStyle: {
              alignment: {
                horizontal: "left",
                vertical: "center",
                wrapText: true,
              },
              font: {
                sz: 11,
              },
            },
          },
        };
        new ExcelDownload(payload);
      }, 100);
    },
  },
};
</script>

<style scoped lang="scss">
.management-modal-mask {
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  font-size: 1rem;
}

.products-modal-content-container {
  background-color: white;
  border-radius: 12px;
  height: 65vh;
  overflow-x: auto;
  padding: 0 2vw;
}

.management-modal-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 10px 10px 0px 0px;
  background-color: var(--primary-color);
}

.management-modal-header-title {
  color: #ffffff;
  font-weight: 500;
  font-size: 1rem;
  margin-bottom: 0 !important;
}

.management-modal-closebtn-icon {
  color: #ffffff;
  font-size: 2em;
  cursor: pointer;
}

.management-modal-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2vh;
}

.manage-categories__input {
  width: 16vw;
  height: 6vh;
  padding: 0px 10px;
  border: 1px solid #c2c2c3;
  border-radius: 5.23px;
  font-weight: 400;
  font-size: 1.1em;
  color: #a1a1a1;
}

.management-modal-body-title {
  color: #898989;
  font-weight: 500;
  font-size: 1.5em;
}

.modal-table-header {
  display: flex;
  background: #fffefc;
  border: 0.5px solid #e5e5e5;
  padding: 1vh 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 17px;
  color: #605f5f;
  margin-bottom: 1vh;
}

.modal-table-colum-id {
  width: 20%;
  padding-left: 0.5vw;
}

.modal-table-colum-name {
  flex: 1;
  padding-left: 0.5vw;
}
.modal-table-colum-action {
  width: 15%;
  padding-left: 0.5vw;
}
.modal-table-delete-icon {
  color: lightcoral;
  cursor: pointer;
}

.modal-table-row {
  display: flex;
  font-weight: 300;
  font-size: 0.8rem;
  color: #605f5f;
  padding: 0vh 0;
  margin-bottom: 1vh;
  align-items: center;
}
.modal-empty-list {
  text-align: center;
  color: #898989;
}
.management-modal-inputs-container-wrapper {
  display: flex;
  flex-direction: column;
}
.management-modal-inputs-container-title {
  color: #898989;
  font-weight: 400;
  font-size: 1.2rem;
  letter-spacing: 0.15px;
}
.manage-categories__input {
  width: 27vw;
  height: 5vh;
  padding: 0px 10px;
  border: 1px solid #c2c2c3;
  border-radius: 5.23px;
  font-weight: 400;
  font-size: 0.8rem;
  color: #a1a1a1;
}
@media only screen and (max-width: 800px) {
  .manage-categories__input {
    width: 60vw;
  }
  .mobile-button-size {
    width: 50%;
    justify-content: center;
  }
}
</style>
